import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { AbstractWidgetComponent, HttpService } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { AdditionalVisitor, InviteVisitor } from '../additional-visitor.model';
import { environment } from 'src/environments/environment';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';

@Component({
  selector: 'app-additional-visitor',
  templateUrl: './additional-visitor.component.html',
  styleUrls: ['./additional-visitor.component.scss']
})
export class AdditionalVisitorComponent extends AbstractWidgetComponent implements OnInit {

  masterdataForm = new FormGroup({});

  inviterId: number;
  currentAdditionalVisitor = new InviteVisitor();
  additionalVisitors = new Array<AdditionalVisitor>();

  constructor(
    private httpService: HttpService,
    public translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.masterdataForm.addControl('name', new FormControl(null, [Validators.required]));
    this.masterdataForm.addControl('firstname', new FormControl(null, [Validators.required]));
    this.masterdataForm.addControl('mail', new FormControl(null, [Validators.required]));
    this.masterdataForm.statusChanges.subscribe(s => {
      console.log('form status', this.masterdataForm.valid, this.masterdataForm);
    });
  }

  onContextChange(contextChange: ContextChange) {
    console.log('onContextChange', contextChange);
    if (contextChange.key === 'additionalVisitors') {
      this.additionalVisitors = contextChange.value;
    }
  }

  onSetElementAndContext() {
    console.log('onContextChange', this.dashboardContext.getContextValue('additionalVisitors'));
    this.inviterId = this.dashboardContext.getContextValue(TerminalContextConstants.registrationId);
    this.currentAdditionalVisitor = new InviteVisitor();
    this.currentAdditionalVisitor.inviterId = this.inviterId;
    this.additionalVisitors = this.dashboardContext.getContextValue('additionalVisitors');
    this.masterdataForm.valueChanges.subscribe(values => {
      this.currentAdditionalVisitor.firstname = values.firstname;
      this.currentAdditionalVisitor.name = values.name;
      this.currentAdditionalVisitor.mail = values.mail;
      this.currentAdditionalVisitor.phone = values.phone;
    });
  }

  inviteAdditionalVisitor() {
    this.dashboardContext.setContextValue('inviteVisitor', this.currentAdditionalVisitor);
    this.currentAdditionalVisitor = new InviteVisitor();
    this.currentAdditionalVisitor.inviterId = this.inviterId;
    this.masterdataForm.patchValue({
      name: '',
      firstname: '',
      mail: '',
      phone: ''
    });

  }

}
